
import React from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import classnames from 'classnames';


const ID = 'component-toast';

Toast.propTypes = {
  type: PropTypes.oneOf(['text', 'success', 'failure', 'loading']),
  content: PropTypes.node,
  onHideEnd: PropTypes.func,
  onShowEnd: PropTypes.func,
  visible: PropTypes.bool,
  duration: PropTypes.number, // 动画持续时间
  timingFunction: PropTypes.string
};

Toast.defaultProps = {
  type: 'text',
  visible: false,
  duration: 500,
  timingFunction: 'ease'
};

export default function Toast(props) {
  const {
    className, style, type, duration, timingFunction, visible, content,
    onShowEnd, onHideEnd, ...rest
  } = props;
  const cls = classnames(ID, className);
  const styles = {
    ...style,
    transitionDuration: (`${duration}ms`),
    transitionTimingFunction: timingFunction
  };

  return (
    <TransitionGroup component={null}>
      {visible ? (
        <CSSTransition
          classNames={ID}
          timeout={{ exit: duration, enter: duration }}
          onEntered={onShowEnd}
          onExited={onHideEnd}
        >
          <div
            {...rest}
            className={cls}
            style={styles}
          >
            <div className={`${ID}-main`}>
              <div className={`${ID}-content`}>{content}</div>
            </div>
          </div>
        </CSSTransition>
      ) : null}
    </TransitionGroup>
  );
}
